import { IconProps, defaultIconProps } from "./types";

export const EarthIcon = ({
  size = defaultIconProps.size,
  color,
  className = "",
  strokeWidth = defaultIconProps.strokeWidth,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    className={className}
    style={{ color }}
    fill="none"
    viewBox="0 0 16 16"
  >
    <g clipPath="url(#sw-clip-earth-icon)">
      <path
        d="M14.3599 9.99967H11.3333C10.9796 9.99967 10.6405 10.1402 10.3904 10.3902C10.1404 10.6402 9.99992 10.9794 9.99992 11.333V14.3597M4.66659 2.22634V3.33301C4.66659 3.86344 4.8773 4.37215 5.25237 4.74722C5.62744 5.12229 6.13615 5.33301 6.66659 5.33301C7.02021 5.33301 7.35935 5.47348 7.60939 5.72353C7.85944 5.97358 7.99992 6.31272 7.99992 6.66634C7.99992 7.39967 8.59992 7.99967 9.33325 7.99967C9.68687 7.99967 10.026 7.8592 10.2761 7.60915C10.5261 7.3591 10.6666 7.01996 10.6666 6.66634C10.6666 5.93301 11.2666 5.33301 11.9999 5.33301H14.1133M7.33325 14.633V11.9997C7.33325 11.6461 7.19278 11.3069 6.94273 11.0569C6.69268 10.8068 6.35354 10.6663 5.99992 10.6663C5.6463 10.6663 5.30716 10.5259 5.05711 10.2758C4.80706 10.0258 4.66659 9.68663 4.66659 9.33301V8.66634C4.66659 8.31272 4.52611 7.97358 4.27606 7.72353C4.02601 7.47348 3.68687 7.33301 3.33325 7.33301H1.36659M14.6666 7.99967C14.6666 11.6816 11.6818 14.6663 7.99992 14.6663C4.31802 14.6663 1.33325 11.6816 1.33325 7.99967C1.33325 4.31778 4.31802 1.33301 7.99992 1.33301C11.6818 1.33301 14.6666 4.31778 14.6666 7.99967Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="sw-clip-earth-icon">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
